module.exports = {"370783001":"圣城街道","370783003":"文家街道","370783004":"古城街道","370783005":"洛城街道","370783006":"孙家集街道","370783100":"化龙镇","370783103":"营里镇","370783104":"台头镇","370783106":"田柳镇","370783108":"上口镇","370783109":"侯镇","370783111":"纪台镇","370783112":"稻田镇","370783115":"羊口镇","370783400":"双王城生态经济园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370783.json
// module id = 1539
// module chunks = 0